// extracted by mini-css-extract-plugin
export default {"card":"card_card__nGh8t","cardDetails":"card_cardDetails__-Xlsh","projectTitle":"card_projectTitle__Njzji","cardImg":"card_cardImg__vGV8L","languages":"card_languages__4et7y"};